import { rewriteImageUrl } from '../../../helpers';

interface SingleCardDisplayProps {
  cardCoverUrl: string;
}
export default function SingleCardDisplay(
  props: Readonly<SingleCardDisplayProps>,
) {
  const { cardCoverUrl } = props;
  return (
    <div className="my-account-slide">
      <img draggable={false} src={rewriteImageUrl(cardCoverUrl)} alt="" />
    </div>
  );
}
